import { render, staticRenderFns } from "./password-reset-form.vue?vue&type=template&id=c2e0a604&"
import script from "./password-reset-form.vue?vue&type=script&lang=js&"
export * from "./password-reset-form.vue?vue&type=script&lang=js&"
import style0 from "./password-reset-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnForm: require('/usr/src/app/components/ln-form/ln-form.vue').default})
